<div class="icon-list-container position-relative">
  <div class="icon-list position-fixed top-0 end-0 p-m">
    @if(profileService.profile() !== null) {
      @if (domainSwitchingForAll || capabilities.capabilities().developer) {
        <div class="api-switcher d-inline-flex align-items-center p-1">
          <app-form-dropdown
            [fG]="apiUrlForm"
            [fCN]="'apiUrl'"
            [dataSource]="apiDomainOptions"
            [ariaLabel]="'API domain'"
            [cssClass]="'api-switcher-select'"
            [popupWidth]="'auto'"
            [width]="'8rem'"
            (valueChange)="switchApiUrl($event)"
          ></app-form-dropdown>
        </div>
      }
      @if (isHomeRoute()) {
        <app-tooltip [text]="('DASHBOARDSEARCHWIKI' | translate)" [opensOn]="'Auto'" [position]="'BottomCenter'">
          <app-icon-badge (click)="routerService.navigateTo('/knowledgebase')" [style]="'barTop'" [icon]="'search'" [screenReaderText]="'DASHBOARDSEARCHWIKI' | translate"></app-icon-badge>
        </app-tooltip>
      }
      <app-tooltip [text]="('SRNEWALERTS' | translate)" [opensOn]="'Auto'" [position]="'BottomCenter'">
        <app-icon-badge (click)="setTab('notifications')" [style]="'barTop'" [icon]="'notifications'" [alert]="hasNonChatBadgeAlert()" [screenReaderText]="'SRNEWALERTS' | translate"></app-icon-badge>
      </app-tooltip>
      @if (capabilities.capabilities().chat !== null) {
        <app-tooltip [text]="('SRNEWMASSAGES' | translate)" [opensOn]="'Auto'" [position]="'BottomCenter'">
          <app-icon-badge (click)="setTab('chat')" [style]="'barTop'" [icon]="'chat_bubble'" [alert]="iconsBadges.get('chat') ?? false" [screenReaderText]="'SRNEWMASSAGES' | translate"></app-icon-badge>
        </app-tooltip>
      }

      <div class="dropdown d-inline p-1">
        <button type="button" class="btn btn-link p-0 text-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-display="static">
          <app-avatar [image]="profileService.profile()?.user?.avatar?.url?.responsive || ''" [name]="profileService.profile()?.user?.first_name + ' ' + profileService.profile()?.user?.last_name" [type]="'small'"></app-avatar>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li><app-link (click)="profileLanguageDialog = true;" [title]="('LANGUAGE' | translate)" [style]="'dropdown'">{{ ('LANGUAGE' | translate) }}</app-link></li>
          @if(customerService.customerResource()?.translation){
            <li>
              <app-link
                (click)="toggleAutomaticTranslation()"
                [title]="('AUTOTRANSLATEONOFF' | translate)"
                [style]="'dropdown'"
              >
                <span
                  [ngClass]="{
                    'text-primary': profileService.profile()?.user?.auto_translation,
                    'text-muted': !profileService.profile()?.user?.auto_translation
                  }"
                  class="d-inline-flex align-items-center gap-1"
                >
                  <div class="mts-icon notranslate" translate="no">language</div>
                  {{ ('AUTOTRANSLATEONOFF' | translate) }}
                </span>
              </app-link>
            </li>
          }
          <li><hr class="dropdown-divider"></li>
          <li><app-link (click)="routerService.navigateTo('/profile')" [title]="('PROFILE' | translate)" [style]="'dropdown'">{{ ('PROFILE' | translate) }}</app-link></li>
          <li><app-link (click)="profilePushDialog = true;" [title]="('NOTIFICATIONSETTINGS' | translate)" [style]="'dropdown'">{{ ('NOTIFICATIONSETTINGS' | translate) }}</app-link></li>
          @if (capabilities.capabilities().home.user_menu_management) {
            <li><app-link (click)="homeIconsDialog.set(true)" [title]="('MENUSETTINGS' | translate)" [style]="'dropdown'">{{ ('MENUSETTINGS' | translate) }}</app-link></li>
          }
          <li><app-link (click)="appDownloadDialog = true;" [title]="('APPDOWNLOAD' | translate)" [style]="'dropdown'">{{ ('APPDOWNLOAD' | translate) }}</app-link></li>
          <li><app-link (click)="openUserMenuModeDialog()" [title]="('SETTINGSMENUUSERDISPLAYMODE' | translate)" [style]="'dropdown'">{{ ('SETTINGSMENUUSERDISPLAYMODE' | translate) }}</app-link></li>
          @if(capabilities.capabilities().settings.global_settings) {
            <li><hr class="dropdown-divider"></li>
            <li><app-link (click)="assistanceDialog = true" [title]="('ASSIST' | translate)" [style]="'dropdown'">{{ ('ASSIST' | translate) }}</app-link></li>
            <li><app-link (click)="openPlatformInfo()" [title]="('PLATFORMINFO' | translate)" [style]="'dropdown'">{{ ('PLATFORMINFO' | translate) }}</app-link></li>
          }
          <li><hr class="dropdown-divider"></li>
          <li><app-link (click)="signOut()" [title]="('SIGNOUT' | translate)" [style]="'dropdown'">{{ ('SIGNOUT' | translate) }}</app-link></li>
        </ul>
      </div>
    }

    @if (tab) {
      <div class="notification-window shadow-lg p-3 d-flex flex-column">
        @if (tab === 'notifications') {
          <div class="d-flex justify-content-end align-items-center mb-2">
            <app-form-button [style]="'btn'" (click)="closeTab()" [cssClass]="'btn-close'"></app-form-button>
          </div>
        }
        @if (tab === 'chat') {
          <div class="d-flex justify-content-between align-items-center mb-2">
            <app-headline [title]="('CHATNOTIFICATIONS' | translate)" [type]="'h6'"></app-headline>
            <div class="d-flex align-items-center">
              <div class="dropdown me-2">
                <div data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                  <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                </div>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li><app-link (click)="setRead('chat')" [title]="('BELLSETALLREAD' | translate)" [style]="'dropdown'">{{ ('BELLSETALLREAD' | translate) }}</app-link></li>
                </ul>
              </div>
              <app-form-button [style]="'btn'" (click)="closeTab()" [cssClass]="'btn-close'"></app-form-button>
            </div>
          </div>
        }
        @if (tab === 'notifications') {
          <div class="d-flex">
            <app-form-button [text]="'NEW' | translate" [cssClass]="status === 'unread' ? 'e-primary w-100 mx-1' : 'e-outline w-100 mx-1'" (click)="setStatusUnread()"></app-form-button>
            <app-form-button [text]="'READ' | translate" [cssClass]="status === 'read' ? 'e-primary w-100 mx-1' : 'e-outline w-100 mx-1'" (click)="setStatusRead()"></app-form-button>
          </div>
        }
        @if (tab === 'notifications') {
          <div class="d-flex justify-content-between align-items-center mt-3 pb-1">
            <app-headline [type]="'h6'" [title]="('NOTIFICATIONS' | translate)"></app-headline>
            @if (tab === 'notifications') { 
              <div class="dropdown">
                <div data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                  <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                </div>
                <ul class="dropdown-menu dropdown-menu-end">
                  @if (status === 'read') {
                    <li><app-link (click)="setUnread('notifications')" [title]="('BELLSETALLUNREAD' | translate)" [style]="'dropdown'">{{ ('BELLSETALLUNREAD' | translate) }}</app-link></li>
                  } @else {
                    <li><app-link (click)="setRead('notifications')" [title]="('BELLSETALLREAD' | translate)" [style]="'dropdown'">{{ ('BELLSETALLREAD' | translate) }}</app-link></li>
                  }
                </ul>
              </div>
            }
          </div>
        }
        @if (profileService.profile()) {
          @if (
            !profileService.profile()!.notifications.send_from_chat ||
            !profileService.profile()!.notifications.send_to_web ||
            firebaseService.notificationState() !== 'granted'
          ) {
            <app-warning 
              [message]="'WARNINGNOTIFICATIONS' | translate" 
              [linkText]="'WARNINGNOTIFICATIONSLINK' | translate" 
              [emitClickOnWholeElement]="true"
              (click)="profilePushDialog = true;"
            >
            </app-warning>
            }
          }
        @if (tab === 'notifications') {
          <div class="d-flex justify-content-end mb-1" >
            <div class="col-md-6">
              <app-form-dropdown [fG]="filterForm" [fCN]="'module'" [dataSource]="activeChannels()" [icon]="'filter_list'" [cssClass]="'small-filter-dropdown'" ></app-form-dropdown>
            </div>
          </div>
        }
        <div class="custom-scrollbar" (scrollend)="layoutService.setScrollToEnd($event, 'bar-top')">
          @for (item of notifications(); track $index) {
            @if (shouldShowNotificationDateDivider($index)) {
              <app-divider-date [date]="formatDividerDate(item)"></app-divider-date>
            }
            <app-notification 
            [notification]="item"
            [variant]="'compact'"
            (asRead)="markNotificationRead($event)"
            (asUnread)="markNotificationUnread($event)"
              >
            </app-notification>
          } @empty {
            @if (shouldShowNoNotificationsMessage()) {
              <div class="p-2 text-muted text-center">
                {{ 'NONOTIFICATIONSTODISPLAY' | translate }}
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>

@if (!isHomeRoute()) {
  <div class="home-icon-container position-relative">
    <div class="home-icon position-fixed top-0 start-0 p-2">
      <app-tooltip [text]="('HOME' | translate)" [opensOn]="'Auto'" [position]="'RightCenter'">
        <app-form-button [style]="'btn'" [icon]="'apps'" [cssClass]="'btn btn-link p-m text-muted position-relative'" [iconClass]="'fs-3'" (click)="routerService.navigateTo('/home')"></app-form-button>
      </app-tooltip>
    </div>
  </div>
}

@if (profileLanguageDialog) {
  <app-dialog-profile-language [(visible)]="profileLanguageDialog"></app-dialog-profile-language>
}
@if (profilePushDialog) {
  <app-dialog-profile-push [(visible)]="profilePushDialog"></app-dialog-profile-push>
}
@if (homeIconsDialog()) {
  <app-dialog-home-icons [visible]="homeIconsDialog()" (visibleChange)="homeIconsDialog.set($event)"></app-dialog-home-icons>
}
@if (userMenuModeDialog()) {
  <ejs-dialog
    target=".dialogs"
    class="simple-dialog"
    [visible]="userMenuModeDialog()"
    [animationSettings]="{ effect: 'Zoom', duration: 400 }"
    [isModal]="true"
    [allowDragging]="false"
    [width]="'50vw'"
    [height]="'auto'"
    [zIndex]="999"
    [showCloseIcon]="true"
    (beforeClose)="closeUserMenuModeDialog()"
  >
    <ng-template #header>
      <div class="d-flex align-items-center justify-content-center">
        <app-headline [title]="('SETTINGSMENUUSERDISPLAYMODE' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
        <app-tooltip 
          [icon]="'help'" 
          [iconClass]="'fs-5 p-1'" 
          [text]="('SETTINGSMENUUSERDISPLAYMODEHELP' | translate)" 
          [width]="'300px'" 
          [height]="'100px'" 
          [cssClass]="'helpTooltip p-2'" 
          [opensOn]="'Click'">
        </app-tooltip>
      </div>
    </ng-template>
    <ng-template #content>
      <div class="d-flex flex-column gap-3 p-3">
        <app-form-radio
          [fCN]="'modeSource'"
          [fG]="userMenuModeForm"
          [value]="'default'"
          [placeholder]="'USERMENUMODEUSEDEFAULT' | translate"
          [name]="'userMenuModeSource'"
          [cssClass]="'e-normal'"
          [disabled]="userMenuModeLoading() || userMenuModeSaving()"
        ></app-form-radio>
        <app-form-radio
          [fCN]="'modeSource'"
          [fG]="userMenuModeForm"
          [value]="'own'"
          [placeholder]="'USERMENUMODEUSEOWN' | translate"
          [name]="'userMenuModeSource'"
          [cssClass]="'e-normal'"
          [disabled]="userMenuModeLoading() || userMenuModeSaving()"
        ></app-form-radio>
        @if (userMenuModeUsesOwnSetting()) {
          <app-form-dropdown
            [fG]="userMenuModeForm"
            [fCN]="'displayMode'"
            [dataSource]="userMenuModeOptions()"
            [placeholder]="'SETTINGSMENUUSERDISPLAYMODE' | translate"
            [disabled]="userMenuModeLoading() || userMenuModeSaving()"
          ></app-form-dropdown>
        }
      </div>
    </ng-template>
    <ng-template #footerTemplate>
      <div class="d-flex align-items-center justify-content-center p-2">
        <app-form-button
          [text]="'SAVE' | translate"
          (click)="saveUserMenuMode()"
          [disabled]="userMenuModeLoading() || userMenuModeSaving()"
          [cssClass]="'e-btn e-primary mx-auto w-50'"
        ></app-form-button>
      </div>
    </ng-template>
  </ejs-dialog>
}
<app-app-download-dialog [(visible)]="appDownloadDialog"></app-app-download-dialog>
<app-assistance-dialog [(visible)]="assistanceDialog"></app-assistance-dialog>
